import axios from './api';

const API_URL = '/caroussel/';

const createCaroussel = async (userData) => {
  const response = await axios.post(API_URL,userData);
  return response.data;
};

const getAll = async() => {
  const response = await axios.get(API_URL);
  return response.data;
};

const reoderCaroussel = async(data) => {
  const response = await axios.patch(API_URL,data);
  return response.data;
};

const DeleteCaroussel = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const CarousselService = {
  DeleteCaroussel,
  getAll,
  createCaroussel,
  reoderCaroussel
};

export default CarousselService;
